import React from "react";

import InfoOutlined from "@material-ui/icons/InfoOutlined";
import Tooltip from '@material-ui/core/Tooltip';
import InputAdornment from "@material-ui/core/InputAdornment";

class ToolTipIcon extends React.Component {

  constructor(props) {
    super(props);
    const tooltipText = this.getToolTipText(props.tooltipText)
    var asAdornment = true
    var displayText = <InfoOutlined/>
    if (props.asAdornment !== undefined) {
      asAdornment = props.asAdornment
    }
    if (props.displayTextPrefix !== undefined) {
      displayText = (<div>{props.displayTextPrefix}<InfoOutlined/></div>)
    }
    this.state = {
      tooltipText: tooltipText,
      asAdornment: asAdornment,
      displayText: displayText
    }
  }

  static getDerivedStateFromProps(nextProps, prevState){
    if(nextProps.tooltipText!==prevState.tooltipText){
      return { tooltipText: nextProps.tooltipText};
    }
    else return null;
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.tooltipText!==this.props.tooltipText){
      //Perform some operation here
      this.setState({tooltipText: this.props.tooltipText});
    }
  }

  getToolTipText(tooltipText) {
    var returnTooltipText = ''
    if (tooltipText !== undefined) {
      returnTooltipText = tooltipText
    } else {
      returnTooltipText = ''
    }
    return returnTooltipText
  }

  render() {
    if (this.state.tooltipText) {
      if (this.state.asAdornment) {
        return (
          <div>
            <InputAdornment position="end" style={this.state.tooltipText ? {} : { display: 'none' }}>
              <Tooltip title={this.state.tooltipText} placement="top-start">
                {this.state.displayText}
              </Tooltip>
            </InputAdornment>
          </div>
        )
      } else {
        return (
          <Tooltip title={this.state.tooltipText} placement="top-start">
            {this.state.displayText}
          </Tooltip>
        )
      }
    } else {
      return (
        <div></div>
      )
    }
  }
}

export default ToolTipIcon;